import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import api from "@/services";

import "./assets/global.scss";
import "./assets/phone.scss";


const app = createApp(App);
//ant
import {
    Modal, message
} from 'ant-design-vue'

app.config.productionTip = false;

app.config.globalProperties.$api = api;
app.config.globalProperties.$message = message;
app.config.globalProperties.$Modal = Modal;
app.config.globalProperties.$nzconfirm = function nzconfirm(title, callback) {
    Modal.confirm({
        okText: '确认',
        cancelText: '取消',
        title: title,
        onOk: () => {
            return callback();
        }
    })
}

app.use(ElementPlus)
app.use(Antd);
app.use(store).use(router);
app.mount('#app');
